<template>
    <div class="pageMessage">
        <div class="chat" style="padding-bottom:2rem;">
            <van-pull-refresh v-model="isLoading" @refresh="onLoadMoreHistory" style="padding-bottom:2rem;">
                <template v-for="(item,key) in msgList">
                    <div class="item tradesman" v-if="item.admin == null">
                        <div class="item_time">{{ formateDate(item.created_at) }}</div>
                        <div class="item_info clearfix">
                            <img :src="item.userdata.thumb" alt="" class="touxiang f-r">
                            <div class="f-r" v-html="isdingzhi( item )" @click="preview(item)"></div>
                        </div>
                    </div>
                    <div class="item user" v-if="item.admin != null">
                        <div class="item_time">{{ formateDate(item.created_at) }}</div>
                        <div class="item_info clearfix">
                            <img :src="$publicData.defaultTouxiang" alt="" class="touxiang f-l">
                            <div class="f-l" v-html="isdingzhi( item )" @click="preview(item)"></div>
                        </div>
                    </div>
                </template>
            </van-pull-refresh>
        </div>
        <div class="fix_bottom_chat_form">
            <van-uploader class="chatsend" :after-read="onRead"><img :src="publicPath + 'statics/images/icon_sendimage.png'" /></van-uploader>
            <button class="chat_send f-r" :disabled="isSendingMessage" @click="sendMsg"><img :src="publicPath+'statics/images/icon_sendmsg.png'" /></button>
            <input type="text" class="chat_input" placeholder="在这里输入消息内容～" v-model="msg" />
            
        </div>
    </div>
</template>

<script>
    import router from "../../../.././router";
    import {
        LOGOUT,
        LOGIN
    } from "../../../.././vuex/mutation_types";
    import Vue from 'vue';
    import { ImagePreview } from 'vant';
    import Bridge from '../../../.././vuex/bridge.js'
    Vue.prototype.$bridge = Bridge
    var userAgent = navigator.userAgent

    export default {
        data() {
            return {
                publicPath: process.env.BASE_URL,
                userThumb: null,    // 用户头像
                msg: '',
                msgList: [],    // 消息列表
                pages: {
                    page: 1,
                    size: 10
                },
                isLoading: false,
                isFinished: false,
                token: null,
                isSendingMessage: false
            };
        },
        created: function () {
            //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'naviTitle': '客服消息',
                    }
                }
                this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

                })
                var memberParams = {
                    data: {
                    },
                }
                //加载用户信息
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    console.log(data)
                    if (data.code == 200) {
                        this.token = data.result.token
                        
                    }
                    this.getData(1)
                })
                //注册方法，客户端重新进入页面刷新数据
                this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data)
                })
            } else {
                // 获取列表
                this.token = this.$store.getters.token
                this.getData(1);
            }
        },
        methods: {
            // 获取列表
            getData(isrefrush) {
                var that = this;
                if ( isrefrush == 1 ) {
                    that.pages.page = 1;
                    that.isFinished = false;
                    that.isLoading = false;
                }
                if (that.isFinished) {
                    that.isLoading = false
                    return;
                }
                var token = that.token;
                var param = {
                    token: token,
                    page: that.pages.page,
                    size: that.pages.size
                };
                that.isLoading = true
                that.$api.xiaoxi.customerchatlist(param).then(res => {
                    that.isLoading = false;
                    if (res.code == 200) {
                        if (res.result.length < that.pages.size) {
                            this.isFinished = true;
                        } else {
                            this.isFinished = false;
                        }
                        if ( isrefrush == 1 ) {
                            that.msgList = res.result;
                            setTimeout(function() {
                                $(window).scrollTop($('body').height());
                            }, 100);
                        } else {
                            that.msgList = res.result.concat(that.msgList);
                        }     
                    }
                })
            },
            // 下拉加载更多历史
            onLoadMoreHistory() {
                var that = this;
                that.pages.page++;
                that.getData();
            },
            preview(item) {
                if (item.msg_type == 2) {
                    ImagePreview([item.content]);
                }
            },
            // 发送消息
            sendMsg() {
                var that = this;
                if (that.msg == null || that.msg == undefined || that.msg == '') {
                    return
                }
                // that.msg = JSON.stringify(that.msg);
                var param = {
                    token: that.token,
                    content: that.msg
                };
                that.isSendingMessage = true
                that.$api.xiaoxi.customerchatreply(param).then(res => {
                    console.log(res)
                    that.msg = "";
                    that.isSendingMessage = false
                    that.getData(1);
                })
            },
            onRead: function(file) {
                console.log('file');
                console.log(file);
                var that = this;
                if ($.isArray(file)) {
                    for (var i in file) {
                        this.$api.index
                            .uploadImage({
                                imgFile: file[i].content
                            })
                            .then(res => {
                                if (res.code == 200) {
                                    that.sendImageMsg(res.result.url);
                                }
                            });
                    }
                } else {
                    this.$api.index
                        .uploadImage({
                            imgFile: file.content
                        })
                        .then(res => {
                            if (res.code == 200) {
                                that.sendImageMsg(res.result.url);
                            }
                        });
                }
            },
            sendImageMsg(imgUrl) {
                console.log('上传图片：：：：：', imgUrl);
                var that = this;
                var that = this;
                if (imgUrl == null || imgUrl == undefined || imgUrl == '') {
                    return
                }
                // that.msg = JSON.stringify(that.msg);
                var param = {
                    token: that.token,
                    content: imgUrl,
                    msg_type: 2
                };
                that.isSendingMessage = true
                that.$api.xiaoxi.customerchatreply(param).then(res => {
                    console.log(res)
                    that.msg = "";
                    that.isSendingMessage = false
                    that.getData(1);
                })
            },
            // 格式化日期
            formateDate(time) {
                console.log('time:',time)
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    return time
                }
                let dates = new Date(time.replace(/-/g,'/'));
                console.log(dates)
                var fDate = dates.getFullYear() + '-' + (dates.getMonth() + 1) + '-' + dates.getDate();
                var fTime = dates.getHours() + ":" + dates.getMinutes() + ':' + dates.getSeconds();

                // 获取今天
                var today = new Date();
                var tDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                if (new Date(fDate + ' 00:00:00').getTime() == new Date(tDate + ' 00:00:00').getTime()) {
                    return '今天 ' + fTime;
                } else if (new Date(fDate + ' 00:00:00').getTime() == new Date(tDate + ' 00:00:00').getTime() - 24 * 3600 * 1000) {
                    return '昨天 ' + fTime;
                } else {
                    return fDate + ' ' + fTime;
                }
            },
            // 定制信息格式化
            isdingzhi(item) {
                console.log(msg)
                var msg = item.content
                msg = typeof msg == 'Object' || typeof msg == 'object' ? JSON.stringify(msg) : msg;
                if (msg.indexOf('dingzhi://') > -1) {
                    // if ( msg.indexOf('"') > -1 ) {
                    //     msg = msg.substring(0,msg.length-1);
                    // }
                    msg = msg.replace(/(^\"*)|(\"*$)/g, "")
                    console.log(msg);
                    // return;
                    msg = msg.substr(msg.indexOf('{'));
                    console.log(msg);
                    msg = msg.replace(/\\\"/g, '"')
                    // return;
                    msg = JSON.parse(msg);
                    console.log(msg);
                    return '<a href="' + msg.url + '" class="dingzhi_tpl clearfix">'
                        + '<div class="d_msg">'
                        + '<h3>' + msg.title + '</h3>'
                        + '<p>' + msg.detail + '</p>'
                        + '</div>'
                        + '<img src="' + msg.image + '" class="d_thumb" />'
                        + '</a>';
                }
                if (item.msg_type == 2) {
                    return '<div class="xiaoxi" ><img src="' + msg + '" class="form_tu" /></div>';
                } 
                return '<div class="xiaoxi" >' + msg + '</div>';
            }

        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>